import styled from 'styled-components';
import wixService from '../../../../../../services/wixService';

function getMobileCategoryFontSize(settings) {
  return settings.isNewApp && wixService.isMobile()
    ? settings.mobile.categoryFontSize + 'px !important'
    : '';
}
function getColorWithoutOpacity(color) {
  try {
    if (typeof color !== 'undefined' && color !== '') {
      return wixService.getTinycolor(color).setAlpha(100).toRgbString();
    }
  } catch (e) {
    console.log('e:', color);
    return color;
  }
}

function getScrollBarBG(stripColor) {
  try {
    if (typeof stripColor !== 'undefined' && stripColor !== '') {
      return wixService.getTinycolor(stripColor).setAlpha(0.3).toRgbString();
    }
  } catch (e) {
    console.log('e:', stripColor);
    return stripColor;
  }
}

export const CusttomScrollBar = styled.div`
  /*&.flexbox-grow.fixedScrollbarHeight {
    height: 200px !important;
  }*/
  &.fixedScrollbar::-webkit-scrollbar-thumb {
    background-color: ${(props) =>
      getScrollBarBG(
        wixService.getColorByreference(props.design.questionText.color.value),
      )};
    background-color: ${(props) =>
      getScrollBarBG(
        wixService.getColorValueByComponentName(
          props.styleParams,
          props.design.questionText.color.name,
        ),
      )};
  }
`;

export const CategoriesListBlock = styled.div`


  [aria-selected='false']:hover {
    background-color: transparent !important;
    cursor: pointer;
  }

  color: ${(props) =>
    wixService.getColorByreference(
      props.settings.layout === 'stripes'
        ? props.design.questionStripesText.color.value
        : props.design.questionText.color.value,
    )};

  color: ${(props) =>
    wixService.getColorValueByComponentName(
      props.styleParams,
      props.settings.layout === 'stripes'
        ? props.design.questionStripesText.color.name
        : props.design.questionText.color.name,
    )};

  [data-hook='dropdown-base-text'],
  [data-hook='native-select'] {
    ${(props) =>
      wixService.getStyleFontByReference(
        props.design.categoryOtherText.font.value,
      )};
    font: ${(props) =>
      wixService.getFontValueByComponentName(
        props.styleParams,
        props.design.categoryOtherText.font.name,
      )};
    font-size: 14px !important;
    line-height: 20px !important;
    font-size: ${(props) => getMobileCategoryFontSize(props.settings)};
    text-decoration: ${(props) =>
      wixService.getFontTextDecoration(
        props.styleParams,
        props.design.categoryOtherText.font.name,
      )} !important;

    color: ${(props) =>
      wixService.getColorByreference(
        props.isSelectedCategoryTextColor &&
          (props.isSelectedCategoryChanged ||
            props.styleParams.colors.selectedCategoryTextColor.themeName !==
              'color-8')
          ? props.styleParams.colors.selectedCategoryTextColor.themeName
          : props.design.answersLinks.color.value,
      )} !important;

    color: ${(props) =>
      wixService.getColorValueByComponentName(
        props.styleParams,

        props.isSelectedCategoryTextColor &&
          (props.isSelectedCategoryChanged ||
            props.styleParams.colors.selectedCategoryTextColor.themeName !==
              'color-8')
          ? props.design.selectedCategory.color.name
          : props.design.answersLinks.color.name,
      )} !important;
  }
  ${(props) =>
    wixService.getStyleFontByReference(
      props.settings.layout === 'stripes'
        ? props.design.questionStripesText.font.value
        : props.design.questionText.font.value,
    )};
  font: ${(props) =>
    wixService.getFontValueByComponentName(
      props.styleParams,
      props.settings.layout === 'stripes'
        ? props.design.questionStripesText.font.name
        : props.design.questionText.font.name,
    )};

  font-size: 14px !important;
  line-height: 20px !important;
  button,
  label,
  [data-hook='popover-content'],
  [data-hook='native-select'] {
    text-decoration: ${(props) =>
      wixService.getFontTextDecoration(
        props.styleParams,
        props.settings.layout === 'stripes'
          ? props.design.questionStripesText.font.name
          : props.design.questionText.font.name,
      )} !important;
    border-color: ${(props) =>
      wixService.getColorByreference(
        props.settings.layout === 'stripes'
          ? props.design.questionStripesText.color.value
          : props.design.questionText.color.value,
      )} !important;

    border-color: ${(props) =>
      wixService.getColorValueByComponentName(
        props.styleParams,
        props.settings.layout === 'stripes'
          ? props.design.questionStripesText.color.name
          : props.design.questionText.color.name,

        props.design.questionStripesText.color.name,
      )} !important;
  }
  [data-hook='suffix-icon'] {
    color: ${(props) =>
      wixService.getColorByreference(
        props.settings.layout === 'stripes'
          ? props.design.questionStripesText.color.value
          : props.design.questionText.color.value,
      )} !important;

    color: ${(props) =>
      wixService.getColorValueByComponentName(
        props.styleParams,
        props.settings.layout === 'stripes'
          ? props.design.questionStripesText.color.name
          : props.design.questionText.color.name,

        props.design.questionStripesText.color.name,
      )} !important;
  }

  [data-hook='popover-content'] {
    background-color: ${(props) =>
      getColorWithoutOpacity(
        wixService.getColorByreference(props.design.widget.color.value),
      )};
    background-color: ${(props) =>
      getColorWithoutOpacity(
        wixService.getColorValueByComponentName(
          props.styleParams,
          props.design.widget.color.name,
        ),
      )};
  }
  [data-hook='native-select'] {
    background-color: transparent !important;
  }
`;

export const TitleContainerBlock = styled.div`
  color: ${(props) =>
    wixService.getColorByreference(
      props.isCategoryOtherTextColor &&
        (props.isCategoryChanged ||
          props.styleParams.colors.categoryOtherTextColor.themeName !==
            'color-5')
        ? props.styleParams.colors.categoryOtherTextColor.themeName
        : props.settings.layout === 'stripes'
        ? props.design.questionStripesText.color.value
        : props.design.questionText.color.value,
    )} !important;

  color: ${(props) =>
    wixService.getColorValueByComponentName(
      props.styleParams,
      props.isCategoryOtherTextColor &&
        (props.isCategoryChanged ||
          props.styleParams.colors.categoryOtherTextColor.themeName !==
            'color-5')
        ? props.design.categoryOtherText.color.name
        : props.settings.layout === 'stripes'
        ? props.design.questionStripesText.color.name
        : props.design.questionText.color.name,
    )} !important;

  ${(props) =>
    wixService.getStyleFontByReference(
      props.design.categoryOtherText.font.value,
    )};
  font: ${(props) =>
    wixService.getFontValueByComponentName(
      props.styleParams,
      props.design.categoryOtherText.font.name,
    )};
  line-height: 40px !important;

  text-decoration: ${(props) =>
    wixService.getFontTextDecoration(
      props.styleParams,
      props.design.categoryOtherText.font.name,
    )} !important;
  &.active {
    color: ${(props) =>
      wixService.getColorByreference(
        props.isSelectedCategoryTextColor &&
          (props.isSelectedCategoryChanged ||
            props.styleParams.colors.selectedCategoryTextColor.themeName !==
              'color-8')
          ? props.styleParams.colors.selectedCategoryTextColor.themeName
          : props.design.answersLinks.color.value,
      )} !important;

    color: ${(props) =>
      wixService.getColorValueByComponentName(
        props.styleParams,
        props.isSelectedCategoryTextColor &&
          (props.isSelectedCategoryChanged ||
            props.styleParams.colors.selectedCategoryTextColor.themeName !==
              'color-8')
          ? props.design.selectedCategory.color.name
          : props.design.answersLinks.color.name,
      )} !important;
  }
  &.active:focus-visible {
    box-shadow: 0 0 0 1px #ffffff, 0 0 0 3px #116dff !important;
    z-index: 999;
  }
`;

export const OptionsContainerBlock = styled.div.attrs(() => ({}))`
  #optionsContainerBlock::-webkit-scrollbar-thumb {
    background-color: ${(props) =>
      getScrollBarBG(
        wixService.getColorByreference(props.design.questionText.color.value),
      )};
    background-color: ${(props) =>
      getScrollBarBG(
        wixService.getColorValueByComponentName(
          props.styleParams,
          props.design.questionText.color.name,
        ),
      )};
  }

  [data-hook='native-select'] {
    background-color: transparent !important;
  }

  div[aria-selected*='true'] {
    color: ${(props) =>
      wixService.getColorByreference(
        props.design.categoryOtherText.color.value,
      )} !important;

    color: ${(props) =>
      wixService.getColorValueByComponentName(
        props.styleParams,
        props.design.categoryOtherText.color.name,
      )} !important;
  }
`;
